module.exports = __webpack_public_path__ + "img/no_data_icon.6a33b805.svg";